var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9 24.775H30.15V27.5H26.575L26.075 31.5H23.25L23.75 27.5H20.075L19.575 31.5H16.775L17.275 27.5H14V24.775H17.6L18.125 20.725H14.85V18H18.45L18.95 14H21.75L21.25 18H24.925L25.425 14H28.225L27.725 18H30.975L31 20.725H27.4L26.9 24.775ZM24.075 24.775L24.6 20.725H20.925L20.4 24.775H24.075Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHash);
export default __webpack_public_path__ + "static/media/hash.8b7c837be3519422b0598cdc385883eb.svg";
export { ForwardRef as ReactComponent };